/**
 * Copyright (c) 2023-present,
 * Eunoia Digital, S.L. All rights reserved.
 */

export default function getConfig() {
  return {
    publicRuntimeConfig: {
      NEXT_PUBLIC_BIOVERT_GOOGLE_RECAPTCHA_KEY: process.env.NEXT_PUBLIC_BIOVERT_GOOGLE_RECAPTCHA_KEY,
      BIOVERT_GOOGLE_RECAPTCHA_SECRET: process.env.BIOVERT_GOOGLE_RECAPTCHA_SECRET,
      BIOVERT_REDIS_HOST: process.env.BIOVERT_REDIS_HOST,
      BIOVERT_REDIS_PORT: +process.env.BIOVERT_REDIS_PORT,
    },
  };
}
